import { useEffect } from "react";
import { getPromo, getPaymentMethods } from "@a365/api";
import { processedGeo$, loadGeo } from "./services/geolocationService";
import { CORE_CONFIG } from "./a365-core.config";
import { initializeChatBots, getSalesNumber } from "./utils/chat-utils";
import { APPS_NOT_ALLOWED } from "./config/chat";
import {
  getLanguageFromUrl,
  isLocalStorageEnabled,
} from "./utils/language-utils";

const STORAGE_KEYS = {
  VOUCHER: CORE_CONFIG.voucher.storageKeys.voucher,
  VOUCHER2: CORE_CONFIG.voucher.storageKeys.voucher2,
};

const handleVoucherStorage = (voucherCode) => {
  // Clean existing vouchers
  Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));

  // Store new voucher if exists
  if (voucherCode?.trim()) {
    localStorage.setItem(STORAGE_KEYS.VOUCHER, voucherCode);
  }
};

export default function Root(props) {
  useEffect(() => {
    const cleanExistingChat = () => {
      const whatsappButton = document.getElementById("a365-whatsapp-button");
      if (whatsappButton) {
        const phoneNumber =
          whatsappButton.getAttribute("data-phone") || "desconocido";
        whatsappButton.remove();
      }
      const hubspotScript = document.querySelector(
        'script[src^="//js.hs-scripts.com"]'
      );
      if (hubspotScript) {
        hubspotScript.remove();
      }
      document
        .querySelectorAll('iframe[id^="hubspot-messages-iframe"]')
        .forEach((el) => el.remove());
      document
        .querySelectorAll('div[id^="hubspot-messages"]')
        .forEach((el) => el.remove());
    };

    const cleanUsercentricsCMP = () => {
      const usercentricScript = document.getElementById("usercentrics-cmp");
      if (usercentricScript) usercentricScript.remove();
    };

    const setupGeoSubscription = () => {
      try {
        const pathSegments = window.location.pathname.split("/");
        const currentPath = pathSegments[2];

        const excludedPaths = ["products", "checkout", "assist-pay"];
        const storage = !excludedPaths.includes(currentPath);

        loadGeo(storage, false, null);

        const subscription = processedGeo$.subscribe((geoData) => {
          if (!geoData || Object.keys(geoData).length === 0) return;

          handleGeoData(geoData, currentPath);
        });

        return () => {
          subscription.unsubscribe();
        };
      } catch (err) {
        console.error("Error en setupGeoSubscription:", err);
      }
    };

    const handleGeoData = (geoData, currentPath) => {

      if (geoData) {
        const countryCode = geoData?.country.toLowerCase();
        const countryID = geoData.country_id;
        const allowedPathsPromo = CORE_CONFIG.services.promo.allowedPaths;
        const allowedPathsPaymentMethods =
          CORE_CONFIG.services.paymentMethods.allowedPaths;
        const { today_day, today_hour } = geoData;

        if (countryCode && countryID && today_day && today_hour) {
          if (!APPS_NOT_ALLOWED.includes(currentPath)) {
            cleanExistingChat();
            initializeChatBots(countryCode, countryID, today_day, today_hour);
          } else {
            console.info(
              `Chat no inicializado: ${currentPath} está en la lista de aplicaciones no permitidas`
            );
          }
        }

        if (!currentPath && (countryCode === "es" || countryCode === "pt")) {
          try {
            cleanUsercentricsCMP();

            const js = document.createElement("script");
            js.type = "text/javascript";
            js.id = "usercentrics-cmp";
            js.setAttribute("data-settings-id", "tq-RZruuTsnLdp");
            js.async = true;
            js.src = "https://app.usercentrics.eu/browser-ui/latest/loader.js";
            document.getElementsByTagName("head")[0].appendChild(js);
          } catch (error) {
            console.error("Error loading Usercentrics CMP:", error);
          }
        }

        // Inicializar servicio de promociones
        const isLink = currentPath === "assist-pay" ? true : false;
        if (
          (geoData?.country_id && allowedPathsPromo.includes(currentPath)) ||
          !currentPath
        ) {
          getPromo(geoData.country_id);
        }

        // Inicializar servicio de métodos de pago
        if (
          !isLink &&
          geoData?.country_id &&
          allowedPathsPaymentMethods.includes(currentPath)
        ) {
          getPaymentMethods(geoData.country_id);
        }

        // Procesar parámetros de URL y vouchers en la página principal
        if (!currentPath) {
          const urlParams = new URLSearchParams(window.location.search);

          const voucherCode = urlParams.get("voucher");
          handleVoucherStorage(voucherCode);

          if (urlParams.has("lang")) {
            const lang = urlParams.get("lang");
            if (isLocalStorageEnabled()) {
              window.localStorage.setItem("lang", lang);
            }
          }
        }
        const currentLanguage = getLanguageFromUrl();
      }
    };

    return setupGeoSubscription();
  }, []);

  return null;
}
